import { axiosInstance } from '@/plugins/axios';

export default {
	namespaced: true,
	state: {
    meditationCategories: {},
		meditations: {},
    meditation: {},
    isPremium: false,
    tasks: {},
    task: {},
    currentTask: {},
    narrations: {},
    musics: {}
	},
	getters: {
    meditationCategories(state) {
			return state.meditationCategories;
		},
		meditations(state) {
			return state.meditations;
		},
    meditation(state) {
			return state.meditation;
		},
    isPremium(state) {
      return state.isPremium;
    },
    tasks(state) {
			return state.tasks;
		},
    task(state) {
			return state.task;
		},
    currentTask(state){
      return state.currentTask;
    },
    narrations(state) {
			return state.narrations;
		},
    musics(state){
      return state.musics;
    },
	},
	mutations: {
    SET_MEDITATION_CATEGORIES(state, value) {
			state.meditationCategories = value;
		},
		SET_MEDITATIONS(state, value) {
			state.meditations = value;
		},
    SET_MEDITATION(state, value) {
			state.meditation = value;
		},
    SET_IS_PREMIUM(state, value) {
			state.isPremium = value;
		},
    SET_TASKS(state, value) {
			state.tasks = value;
		},
    SET_TASK(state, value) {
			state.task = value;
		},
    SET_CURRENT_TASK(state, value) {
      state.currentTask = value;
    },
    SET_NARRATIONS(state, value) {
			state.narrations = value;
		},
    SET_MUSICS(state, value) {
      state.musics = value;
    },
	},
	actions: {
    async registerCategoryMeditation(context, value) {
      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('name', value.name);

      const url = value.id ? `meditation/categories/${value.id}` : 'meditation/categories';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultCategoriesMeditation');
        })
    },
    async consultCategoriesMeditation(context){
      await axiosInstance({
        method: 'GET',
        url: 'meditation/categories',
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_MEDITATION_CATEGORIES', data]);
        })
    },
    async removeCategoryMeditation(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `meditation/categories/${id}`,
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultCategoriesMeditation');
        })
    },
    async registerMeditation(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('id_meditation_category', value.id_meditation_category);
      formData.append('name', value.name);
      formData.append('description', value.description);
      formData.append('picture', value.picture);
      formData.append('is_premium', value.is_premium);

      const url = value?.id ? `meditation/${value.id}` : 'meditation';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultMeditations');
        })
    },
    async consultMeditations(context, value){
      const url = value?.id ? `meditation/${value.id}` : 'meditation';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.id) {
            context.dispatch('setDataDefault', ['SET_MEDITATION', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_MEDITATIONS', data]);
        })
    },
    async removeMeditation(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `meditation/${id}`,
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_MEDITATION', data]);
        })
    },
    async registerTask(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('id_meditation', value.id_meditation);
      formData.append('id_meditation_narration', value.id_meditation_narration);
      formData.append('name', value.name);
      formData.append('time', value.time);
      formData.append('audio', value.audio);
      formData.append('audio_name', value.audio_name);
      formData.append('is_premium', value.is_premium);

      const url = value?.id ? `meditation/tasks/${value.id}` : 'meditation/tasks';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultTasks');
        })
    },
    async consultTasks(context, value){
      let url;
      if (value?.idPlan) {
        url = `meditation/${value.idPlan}/tasks`;
      } else if (value?.idTask) {
        url = `meditation/tasks/${value.idTask}`;
      } else {
        url = 'meditation/tasks';
      }

      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          if (value?.idTask) {
            context.dispatch('setDataDefault', ['SET_TASK', data]);
            return;
          }
          context.dispatch('setDataDefault', ['SET_TASKS', data]);
        })
    },
    async removeTask(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `meditation/tasks/${id}`,
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_TASKS', data]);
        })
    },
    async registerNarration(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('name', value.name);

      const url = value?.id ? `meditation/narration/${value.id}` : 'meditation/narration';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultNarrations');
        })
    },
    async consultNarrations(context, value){
      const url = value?.id ? `meditation/narration/${value.id}` : 'meditation/narration';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          // if (value?.id) {
          //   context.dispatch('setDataDefault', ['SET_NARRATION', data]);
          //   return;
          // }
          context.dispatch('setDataDefault', ['SET_NARRATIONS', data]);
        })
    },
    async registerMusic(context, value) {

      let formData = new FormData();
      formData.append('id_user', value.id_user);
      formData.append('name', value.name);
      formData.append('picture', value.picture);
      formData.append('music', value.music);
      formData.append('music_name', value.music_name);
      formData.append('music_time', value.music_time);
      formData.append('is_premium', value.is_premium);

      const url = value?.id ? `meditation/music/${value.id}` : 'meditation/music';

      await axiosInstance({
        method: 'POST',
        url: url,
        data: formData
      }).then(response => response.data)
        .then(() => {
          context.dispatch('consultMusics');
        })
    },
    async consultMusics(context, value){
      const url = value?.id ? `meditation/music/${value.id}` : 'meditation/music';
      await axiosInstance({
        method: 'GET',
        url: url,
      }).then(response => response.data)
        .then(data => {
          // if (value?.id) {
          //   context.dispatch('setDataDefault', ['SET_NARRATION', data]);
          //   return;
          // }
          context.dispatch('setDataDefault', ['SET_MUSICS', data]);
        })
    },
    async removeMusic(context, id){
      await axiosInstance({
        method: 'DELETE',
        url: `meditation/music/${id}`,
      }).then(response => response.data)
        .then(data => {
          context.dispatch('setDataDefault', ['SET_MUSICS', data]);
        })
    },
    setCurrentTask(context, value){
      context.commit('SET_CURRENT_TASK', value);
    },
    setDataDefault(context, [mutationName, value]){
      context.commit(`${mutationName}`, value);
    },
	}
}
